import { Component, Input } from '@angular/core';

@Component({
  selector: 'opac-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss']
})
export class NoResultsComponent {
  @Input() label: string;
}
